<template>
  <div>
    <v-carousel
      v-model="step"
      class="v-carousel__container-size"
      :continuous="false"
    >
      <v-carousel-item v-for="(slide, i) in slides" :key="i">
        <div class="d-flex flex-column mt-3">
          <!-- top image -->
          <v-row v-if="slide.start" class="d-flex flex-column my-3">
            <v-img
              v-if="slide.img"
              width="70%"
              class="align-self-center"
              :src="require('@/assets/img/logo-solena-black.png')"
            ></v-img>
          </v-row>
          <!-- title -->
          <div v-if="!slide.end">
            <v-row class="d-flex flex-column align-self-center mx-4 mt-3">
              <span class="font-weight-bold text-center mb-2">
                {{ slide.title }}
              </span>
              <span v-if="slide.subtitle" class="font-weight-bold text-center">
                {{ slide.subtitle }}
              </span>
            </v-row>
            <!-- image or video -->
            <v-row class="d-flex flex-column pt-3">
              <v-img
                v-if="slide.img"
                :src="slide.img"
                class="align-self-center v-carousel__content-img"
              />
              <video
                v-else
                autoplay
                controls
                muted
                playsinline
                :poster="require('@/assets/img/poster.jpg')"
                class="video_intro align-self-center"
              >
                <source :src="slide.video" type="video/mp4" alt="help video" />
              </video>
            </v-row>
          </div>
          <!-- last slide -->
          <v-row v-else class="d-flex flex-column align-self-center fix-center">
            <span class="font-weight-bold text-center mb-6">
              {{ slide.title }}
            </span>
            <v-img
              v-if="slide.img"
              :src="slide.img"
              class="align-self-center v-carousel__content-img"
            />
          </v-row>
          <span class="copyright fix-down">
              D.R. © Solena Ag, Inc. {{new Date().getFullYear()}}
          </span>
        </div>
        <!-- button -->
        <div class="v-window__next v-window__skip" v-if="!slide.end">
          <v-btn
            class="align-self-start mt-1 font-weight-bold"
            text
            @click="skipIntro()"
          >
            Saltar
          </v-btn>
        </div>
        <div class="v-window__next" v-if="slide.end">
          <v-btn
            class="align-self-end mt-1 font-weight-bold"
            text
            @click="dialog = true"
          >
            Hecho
          </v-btn>
        </div>
      </v-carousel-item>
    </v-carousel>
    <v-dialog v-model="dialog" max-width="270">
      <v-card>
        <v-card-title>Confirmación</v-card-title>
        <v-card-text class="pa-3 text-center black--text" style="display:grid">
          ¿Deseas seguir viendo este tutorial cada que ingrese a Solena Explore?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="" text @click="dialog = false">
            CANCELAR
          </v-btn>
          <v-btn color="red" text @click="closeIntro(false)" :loading="loading">
            NO
          </v-btn>
          <v-btn
            color="secondary"
            text
            @click="closeIntro(true)"
            :loading="loading"
          >
            SÍ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data: () => ({
    step: 0,
    dialog: false,
    loading: false,
    slides: [
      {
        title: "Bienvenido a Solena Explore",
        subtitle: "Rentabilizamos tu capital biológico",
        img: require("@/assets/img/solena_scientist.png"),
        start: true,
      },
      {
        title: "¿Cómo instalar Solena Explore en iOS (iPhone)?",
        video: require("@/assets/videos/installIOS.mp4"),
      },
      {
        title: "¿Cómo iniciar sesión?",
        video: require("@/assets/videos/logIn.mp4"),
      },
      {
        title: "¿Dónde ver el detalle de una muestra?",
        video: require("@/assets/videos/sampleDetail.mp4"),
      },
      {
        title: "¿Cómo crear una entrada en bitácora sobre un área?",
        video: require("@/assets/videos/logbook.mp4"),
      },
      {
        title: "¿Cómo crear manejo agronómico en un área?",
        video: require("@/assets/videos/agronomic.mp4"),
      },
      {
        title:
          "Este tutorial estará disponible en la sección 'Ayuda' del menú lateral",
        img: require("@/assets/img/help-on-menu.jpeg"),
        end: true,
      },
    ],
  }),
  methods: {
    closeIntro(val) {
      this.loading = true;
      localStorage.setItem("openIntro", val);
      this.$router.push("/territory");
    },
    skipIntro() {
      this.step = this.slides.length - 1;
    },
  },
};
</script>

<style scoped>
.fix-center {
  width: 90%;
  position: absolute;
  margin: 5%;
  top: 25%;
  text-align: center;
}

.v-carousel__content-img {
  width: 72%;
}

.fix-down {
  width: 100%;
  position: absolute;
  margin: 2% 1%;
  bottom: 0;
  text-align: center;
}
.copyright {
  background-color: #ebebeb !important;
}
</style>
